export default "__VITE_ASSET__CZrk4ttQ__"